/* TLC shared "Pick 3" chooser (Knight 2026-09-24). Root = element with [data-pk3]. */
(function(){
  document.querySelectorAll('[data-pk3]').forEach(function(root){
    var picks=[];
    var inputs=[].slice.call(root.querySelectorAll('[data-pk3-prop]'));
    var slots=[].slice.call(root.querySelectorAll('[data-pk3-slot]'));
    var tiles=[].slice.call(root.querySelectorAll('[data-pk3-tile]'));
    var err=root.querySelector('[data-pk3-err]');
    var sel=root.querySelector('[data-pk3-sel]');
    var slotWrap=root.querySelector('[data-pk3-slots]');
    var slotImg=slotWrap?slotWrap.getAttribute('data-slot-img'):'';
    var imgFor={};
    tiles.forEach(function(t){imgFor[t.getAttribute('data-scent')]=t.getAttribute('data-img');});
    function render(){
      slots.forEach(function(box,i){
        var p=picks[i], nm=box.querySelector('.tlpk-slot-name'), im=box.querySelector('.tlpk-slot-img'), x=box.querySelector('.tlpk-slot-x');
        box.classList.toggle('filled',!!p);
        nm.textContent=p?p:'Tap below';
        im.style.backgroundImage=p?(slotImg?'url('+slotImg+')':imgFor[p]):'';
        x.hidden=!p;
      });
      inputs.forEach(function(inp,i){ if(picks[i]){inp.value=picks[i];inp.disabled=false;} else {inp.value='';inp.disabled=true;} });
      tiles.forEach(function(t){
        /* badge shows WHICH pick(s) this scent is: 1, 2, 3 (or "1 & 3" for a repeat) (Dee 2026-10-01) */
        var pos=[]; picks.forEach(function(s,i){ if(s===t.getAttribute('data-scent')) pos.push(i+1); });
        var b=t.querySelector('.tlpk-tile-badge');
        t.classList.toggle('on',pos.length>0); b.hidden=!pos.length; b.textContent=pos.join(' & ');
      });
      root.classList.toggle('tlpk-full',picks.length===3);
      if(err && picks.length===3) err.hidden=true;
    }
    tiles.forEach(function(t){ t.addEventListener('click',function(){ if(picks.length>=3) return; picks.push(t.getAttribute('data-scent')); render(); }); });
    slots.forEach(function(box,i){
      box.querySelector('.tlpk-slot-x').addEventListener('click',function(e){ e.stopPropagation(); if(i<picks.length){picks.splice(i,1);render();} });
      box.addEventListener('click',function(){ if(!picks[i] && sel) sel.scrollIntoView({behavior:'smooth',block:'start'}); });
    });
    var form=slotWrap && slotWrap.closest('form');
    if(form) form.addEventListener('submit',function(e){
      if(picks.length<3){ e.preventDefault(); if(err) err.hidden=false; if(sel) sel.scrollIntoView({behavior:'smooth',block:'start'}); }
    });
    render();
  });
})();
